import template from './am-assets-list.component.html';
import { Paging, Assetsfilter } from '../../core/models/am-helper.model';
import { pollOnInterval } from '../../core/utilities/am-helper.util';

class AmAssetListController {
  constructor(amAssetsService, $state, amStoreService, $interval, $uibModal) {
    'ngInject';

    this.assetService = amAssetsService;
    this.filter = new Assetsfilter();
    this.filter.facet = null;
    this.paging = new Paging(15, 1);
    this.status = '';
    this.total = null;
    this.$state = $state;
    this.store = amStoreService;
    this.selectedAsset = {};
    this.filtersCount = null;
    this.excludedAssetList = [];
    this.interval = $interval;
    this.poll = false;
    this.uibModal = $uibModal;
    this.addToDataLayer = (data) => window.dataLayer.push(data);
  }

  get SelectedIds() {
    return Object.keys(this.selectedAsset || {});
  }

  $onInit() {
    this.searchFilterConfig = this.searchFilterConfig || this.getDefaultSearchFilterConfig();
    this.status = 'loading';
    this.getAssets().then(() => {
      if (this.poll === true) {
        this.updateInterval = pollOnInterval(this.interval, () => this.getAssets());
      }
    });
  }

  $onChanges() {}

  $onDestroy() {
    if (this.poll === true && this.updateInterval) {
      this.interval.cancel(this.updateInterval);
    }
  }

  updateSearchQuery(queryTerm) {
    this.filter.queries = [queryTerm ? `*${queryTerm}*` : '*'];
    this.getAssets();

    this.addToDataLayer({
      event: 'assetSearching',
      data: {
        keyword: queryTerm,
        page: this.$state.current.name,
      },
    });
  }

  getAssets() {
    let assetFnPromise;

    if (this.getAssetFn) {
      assetFnPromise = this.getAssetFn(this.filter, this.paging);
    } else {
      assetFnPromise = this.assetService.getAssetsWithAccessService(this.filter, this.paging);
    }

    return assetFnPromise
      .then((res) => {
        const filterdAssets = this._markfilterExculudedAssets(res.assets, this.excluded);
        this.assetsList = filterdAssets.selectableList;
        this.excludedAssetList = filterdAssets.unSelectableList;
        this.total = res.total;
        this.status =
          res.total === 0 && this.filter.queries[0] === '*' && this.filtersCount === 0
            ? 'no-enabled-data'
            : '';
      })
      .catch(() => {
        this.status = 'error';
      });
  }

  loadPage(pageNumber) {
    this.paging.currentPage = pageNumber;
    this.getAssets();
  }

  viewAsset(asset) {
    if (asset) {
      this.store.viewedAsset = asset;
      this.$state.go('access-management.asset-view', {
        id: asset.id,
      });
    }
  }

  //filters using filters in map page
  onFilterChanged() {
    this.filter.facet = this.facet || {};
    this.filter.attrs = this.attrsFilter;
    this.getAssets();
  }

  //filter code
  toggleShowFilters(event) {
    this._preventBubbling(event);
    // Toggle the visibility state of the filters
    this.showFilters = !this.showFilters;
  }

  hideFilters() {
    // Make the filters not visible
    this.showFilters = false;
  }

  _preventBubbling(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  _markfilterExculudedAssets(assetsList = [], excludedIds = []) {
    const selectableList = [];
    const unSelectableList = [];
    assetsList.forEach((asset) => {
      excludedIds.includes(asset.id) ? unSelectableList.push(asset) : selectableList.push(asset);
    });
    return { selectableList, unSelectableList };
  }

  getDefaultSearchFilterConfig() {
    return {
      enable: true,
      showSearch: true,
      showFilter: true,
    };
  }
}

export default {
  template,
  controller: AmAssetListController,
  controllerAs: 'assetsVm',
  bindings: {
    selectMode: '<',
    selectedAsset: '=?',
    excluded: '<',
    poll: '<',
    onSelection: '&',
    tableRows: '<',
    enableFilter: '<',
    getAssetFn: '<',
    searchFilterConfig: '<',
    showEnableAssets: '<',
  },
};
